import * as React from 'react';
import { connect } from 'react-redux';
import { Tools } from '../components';
import {
    saveHelper, publishHelper, EModalType, IComponent, EConfirmationOperationType, FeatureHelper, RenewToken,
    JourneyValidationHelper
} from '../helpers';
import store from '../store/store';
import types from '../store/types';

class ToolsContainer extends React.Component<any, any> {

    validateTools = (): boolean => {
        return this.props.state.journeyTitle && this.props.state.journeyTitle.length;
    }

    saveJourney = () => {
        store.dispatch({ type: types.CLEAR_ERROR });

        if (this.validateTools() && JourneyValidationHelper.ValidateJourney()) {
            saveHelper(this.props.state.journeyId, this.props.state, this.props.processState);
        }
        else {
            store.dispatch({ type: types.SET_TOOLS_SAVING, saving: false });
        }
    }

    saveJourneyAs = () => {
        store.dispatch({ type: types.CLEAR_ERROR });
        store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.SaveAs });
        store.dispatch({ type: types.SAVE_AS_JOURNEY_TITLE_CHANGE, journeyTitle: '' });
    }

    publishJourney = () => {
        store.dispatch({ type: types.CLEAR_ERROR });
        if (this.validateTools()) {
            publishHelper(this.props.state.journeyId, this.props.state, this.props.processState)
                .then((response) => {
                    if (response.journeyId) {
                        store.dispatch({
                            type: types.UPDATE_JOURNEY_ID,
                            journeyId: response.journeyId
                        });
                    }
                }
                );
        }
    }

    journeyTitleErrorMessage = (value: string): string => {
        if (value.length) {
            return '';
        }
        else {
            updateJourneyTitle(value);
            return 'Please enter a title for this journey';
        }
    }

    public render() {
        let { journeyTitle, journeyId, saving, isSharedJourney, isTriageJourney, isPageJourney, hideSteps, portalAuthenticationLevel, portaltimeforcompletion } = this.props.state;

        let componentCount = 0;
        if (this.props.processState && this.props.processState.components) {
            for (let componentId in this.props.processState.components) {
                let component: IComponent = this.props.processState.components[componentId];
                //TODO: update this to use a property that indicates that a component is a system component when that property becomes available
                let ignoreComponent: boolean = component && component.Action && component.Action.ActionType && component.Action.ActionType.NameType === 'Journey Information';
                if (!ignoreComponent) {
                    componentCount++;
                }
            }
        }
		// console.log('state --->', store.getState());

        return (
            <Tools
                journeyTitle={journeyTitle}
                journeyId={journeyId}
                saving={saving}
                isSharedJourney={isSharedJourney}
                isTriageJourney={isTriageJourney}
                isPageJourney={isPageJourney}
                hideSteps={hideSteps}
                portalAuthenticationLevel={portalAuthenticationLevel}
                portaltimeforcompletion={portaltimeforcompletion}
                updateJourneyTitle={updateJourneyTitle}
                journeyComponentCount={componentCount}
                saveJourney={this.saveJourney}
                saveJourneyAs={this.saveJourneyAs}
                publishJourney={this.publishJourney}
                journeyTitleErrorMessage={this.journeyTitleErrorMessage}
                validateTools={this.validateTools}
                copy={copyToClipboard}
                settings={FeatureHelper.Supports("journey_settings", this.props.state.features) ? () => {
                    this.props.dispatch({ type: types.TOGGLE_SETTINGS_SIDEBAR });
                    RenewToken();
                } : null}
            />
        );
    }

};

let updateJourneyTitle = (value: string) => {
    store.dispatch({
        type: types.UPDATE_JOURNEY_TITLE,
        journeyTitle: value
    });
    RenewToken();
};

const copyToClipboard = (e) => {

    let journeyId: HTMLInputElement = document.querySelectorAll('[data-input-id="journeyId"]')[0] as HTMLInputElement;
    journeyId.select();
    document.execCommand('copy');
};

let mapStateToProps = (store) => {
    return {
        state: store.toolsState,
        processState: store.processState
    };
};

export default connect<any, any, any>(mapStateToProps)(ToolsContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/tools.tsx